var _style, _path, _path2, _path3, _path4, _polygon, _rect, _rect2, _path5, _path6, _polygon2, _linearGradient, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReservioLogo = function SvgReservioLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 656.3 100",
    viewBox: "0 0 656.3 100",
    height: 21,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:#DC3542;}\n    .st1{fill:url(#a);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m197.1 98.1l-21-39.1c8.8-3.9 14.4-9.7 16.7-18.8 1.2-5 1-11.3-0.1-15.9-3.9-16.2-19.2-21-35.8-21h-38.2v94.9h18.8v-35.5h21l17.6 35.4h21zm-59.6-80.6c20.8 0 25.4-0.9 31.4 3.4 2.4 1.8 3.8 4.2 4.7 7.1 1 3.4 0.8 8 0 11-1.8 6.3-6.3 9-12.8 9.9-3.1 0.4-3.3 0.3-23.2 0.3v-31.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m257.1 31.7c-7.5-6.1-19.1-7.1-28.6-5.4-17 3-25.1 16-25.1 33.6 0 4.9-0.1 8.7 0.7 13.6 2.1 12.1 7.9 19 17.1 23 11.8 5.1 32.9 2.9 45.1-2.6l-2.8-12.7c-7.3 2.7-14.2 4.7-22.1 4.7-13.5 0-19-6.5-19.5-17.9h45.4c-0.1-11.5 1-27.2-10.2-36.3zm-24.8 7.1c2.4-0.4 5.4-0.4 7.9 0.1 7.7 1.6 9 9.4 9.2 17.3h-27.5c0.4-8.1 2.4-16.2 10.4-17.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m279.5 93.8l2.7-13.3c8.3 3.5 18.7 6.2 27.6 5 3.8-0.5 7.7-1.7 8.7-5.4 0.3-1.3 0.4-3-0.1-4.5-0.5-1.7-1.8-2.8-3.4-3.5-10.1-4.3-24.3-1.2-31.7-12.9-4-6.3-7.5-29.4 19.9-32.7 11.5-1.3 22.8 0.7 30.1 4.2l-2.6 13.3c-4.6-2.4-11.5-4.3-19.8-4.3-4.3 0-11 0.5-12.7 4.5-0.6 1.5-0.6 3.4-0.1 4.9 2.7 8.3 26.6 2 35.2 16 3.6 5.8 3.8 16.6-0.8 23.6-5.6 8.4-16.6 10.6-26.8 10.6-9.1 0-18-1.6-26.2-5.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m400.9 31.7c-7.5-6.1-19.1-7.1-28.6-5.4-17 3-25.1 16-25.1 33.6 0 4.9-0.1 8.7 0.7 13.6 2.1 12.1 7.9 19 17.1 23 11.8 5.1 32.9 2.9 45.1-2.6l-2.8-12.7c-7.3 2.7-14.2 4.7-22.1 4.7-13.4 0-19-6.4-19.5-17.9h45.3c0-11.5 1.1-27.2-10.1-36.3zm-24.8 7.1c2.4-0.4 5.4-0.4 7.9 0.1 7.7 1.6 9 9.4 9.2 17.3h-27.5c0.4-8.1 2.5-16.2 10.4-17.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "524.4 27.5 509.1 80.2 494 27.5 474 27.5 498.9 98.1 518.7 98.1 543.6 27.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 554.7,
    width: 19.2,
    height: 17.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 555,
    y: 27.5,
    width: 18.7,
    height: 70.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m622.3 100c-10.5 0-20.8-2.9-27-11.4-7-9.4-6.6-20.6-6.6-28 0-22.4 12.4-35 34.1-35 14.1 0 21.9 4.7 27 11.4 6.8 8.9 6.5 19.3 6.5 27.9 0 22.2-12 35.1-34 35.1zm0.2-14.4c7 0 9.8-2.9 11.7-6 3.2-5.1 2.9-13.9 2.9-19 0-6.4-0.7-13.5-5.1-17.7-4.7-4.5-14.9-4.1-19 0-1.7 1.7-3 3.9-3.8 6.6-2.1 7.3-2.4 23.6 1.6 30.1 2.4 3.9 5.7 6 11.7 6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m463.4 26.6c-6.6-0.5-16.7 1.1-20.9 12.8l-1.2-11.9h-16.4v70.6h18.7v-35.8c0-1.4-0.1-14.7 9.6-18.1 5.6-2 12.1-1 16.5 0.2l-6.3-17.8z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "28.9 3.3 33.9 17.5 29 17.5 44.8 62.8 99.9 62.8 99.9 3.3"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 11.335,
    x2: 54.494,
    y1: 852.41,
    y2: 868.12,
    gradientTransform: "matrix(1 0 0 -1 0 905.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3542",
    offset: 0.079248
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E202A",
    offset: 0.822
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "33.9 17.5 0 17.5 20.8 47.2 0 77 55 77 50 62.8"
  })));
};
export default SvgReservioLogo;